module.exports = __webpack_public_path__ + "static/media/mountains.d4f324e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/mountains.png
// module id = 371
// module chunks = 0